import { ContentType, request } from "../api";
import { baseParams } from "../common";

export const resetPassword = async (data = {}, params = {}) => request({
  path: "/reset-password",
  method: "POST",
  body: { ...baseParams, ...data },
  type: ContentType.Json,
  format: "json",
  ...params,
});
